import axios from 'axios';
import { urlAPI } from '../configurations/constantes';

class FaturamentoService {
    static baixarFatura = (chave) => {
        const ud = JSON.parse(localStorage.getItem('user_data'));

        return axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/demonstrativo`, {
            params: { uuidDocumento: chave }
        });
    };
}

export default FaturamentoService; 